// src/app/modules/Members/pages/members-table/MembersTable.jsx
// 🎯 Adaptive Members Table - Organization Type Aware

import React from "react";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import * as columnFormatters from "./column-formatters";

export function MembersTable({
  members,
  loading,
  onViewDetails,
  onEdit,
  onSuspend,
  onReactivate,
  onDelete,
  onResendInvite,
  onCancelInvite,
  currentPage,
  perPage,
  totalCount,
  onPageChange,
  getLabel,
  hasFeature,
}) {
  const totalPages = Math.max(1, Math.ceil((totalCount || 0) / (perPage || 10)));
  const showDeptUnit = hasFeature('hasStaff') || hasFeature('hasResidents');
  const extra = { onViewDetails, onEdit, onSuspend, onReactivate, onDelete, onResendInvite, onCancelInvite };

  if (loading && !members.length) {
    return <div className="sety-tbl-sub" style={{ padding: 22 }}>Loading…</div>;
  }

  if (!members.length) {
    return <div className="sety-tbl-sub" style={{ padding: 22 }}>No members found.</div>;
  }

  return (
    <div>
      <div className="sety-tbl-wrap">
        <table className="sety-tbl">
          <thead>
            <tr>
              <th>{getLabel('memberName')}</th>
              <th>Role</th>
              {showDeptUnit && <th>{hasFeature('hasResidents') ? getLabel('unit') : 'Department'}</th>}
              <th>Status</th>
              <th>Joined</th>
              <th style={{ textAlign: 'right' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {members.map((row) => (
              <tr key={row.membership_id}>
                <td>{columnFormatters.AdaptiveMemberFormatter(row.user, row, getLabel, hasFeature)}</td>
                <td>{columnFormatters.RoleColumnFormatter(row.role, row)}</td>
                {showDeptUnit && (
                  <td>{columnFormatters.DepartmentUnitFormatter(row.department_or_unit, row, hasFeature)}</td>
                )}
                <td>{columnFormatters.StatusColumnFormatter(row.status, row)}</td>
                <td>{columnFormatters.JoinedDateFormatter(row.joined_at, row)}</td>
                <td style={{ textAlign: 'right' }}>
                  {columnFormatters.ActionsColumnFormatter(null, row, 0, extra)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 22px', borderTop: '1px solid var(--ink-100)',
        }}>
          <span className="sety-tbl-sub">Page {currentPage} of {totalPages}</span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="sety-btn sety-btn-ghost" disabled={currentPage <= 1} onClick={() => onPageChange(currentPage - 1)}>
              <ChevronLeft size={14} />Prev
            </button>
            <button className="sety-btn sety-btn-ghost" disabled={currentPage >= totalPages} onClick={() => onPageChange(currentPage + 1)}>
              Next<ChevronRight size={14} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
